// extracted by mini-css-extract-plugin
module.exports = {"root":"UserInfo_root__36QXc","textCol":"UserInfo_textCol__3GTgb","icon":"UserInfo_icon__4ksTI","gray":"UserInfo_gray__DoNTU"};